<template>
  <el-select
    v-model="p_article_ids"
    multiple
    :multiple-limit="limit"
    filterable
    remote
    reserve-keyword
    placeholder="请输入文章"
    :remote-method="getArticle" @change="change">
    <el-option
      v-for="item in articleTableData"
      :key="item.id"
      :label="item.title"
      :value="(item.id*1)">
    </el-option>
  </el-select>
</template>

<script>
import xhHelp from "../xhHelp";

export default {
  name: "ArticleSysc",
  data(){
    return{
      articleTableData:[],
      p_article_ids:[]
    }
  },
  props:{
    limit:{
      type:Number,
      default(){
        return 0
      }
    },
    article_ids:{
      type:String,
      default() {
        return '';
      }
    },
  },
  model: {
    prop: "p_article_ids", // 定义传递给v-model的那个变量，绑定到哪个属性值上               (默认值value)
    event: "select", // event:什么时候触发v-model行为(让父组件能获取到值)    (默认值input)
  },
  mounted() {

  },
  methods:{
    getArticle(articleKeyword,ids=""){
      xhHelp.get("Article/getList",{keyword: articleKeyword,ids:ids, page: 1, page_size: 50},res => {
        if(res.code == 0) {
          this.articleTableData = res.data.data
        }
      })
    },
    change(e){
      let str=this.p_article_ids?(this.p_article_ids.length?this.p_article_ids.join(','):''):'';
      this.$emit("select",str)
    }
  },
  watch:{
    article_ids(n){
      this.p_article_ids=n?n.split(','):[]
      this.getArticle("",n||"")
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/ArticleSysc.vue